import React from "react";
import useNurses from "@hooks/useNurses";
import NurseSwitchContents from "./NurseSwitchContents";
import CustomModal from "@/components/modal/CustomModal";
import type { ShiftReturnType } from "@/hooks/roster-craete/useShiftsQuery";
import type { NurseResponse } from "@/types/nurse-type";
import type { PrecepteePeriodItem } from "@/hooks/roster-craete/usePrecepteePeriodsQuery";

interface NurseActiveSwitchProps {
  onClose: () => void;
  selectedGroupId?: string | null;
  selectedYear?: number;
  selectedMonth?: number;
  nurseData?: NurseResponse[];
  precepteePeriods?: PrecepteePeriodItem[];
  shiftsData?: ShiftReturnType;
  isUseMid?: boolean;
}

const NurseActiveSwitch: React.FC<NurseActiveSwitchProps> = ({
  onClose,
  selectedGroupId,
  selectedYear,
  selectedMonth,
  nurseData,
  precepteePeriods,
  shiftsData,
  isUseMid = false,
}) => {
  const { isLoading: nurseLoading } = useNurses(selectedGroupId, {
    year: selectedYear,
    month: selectedMonth,
    enabled: !nurseData,
  });

  return (
    <CustomModal.Panel onClose={onClose} isLoading={nurseLoading}>
      <NurseSwitchContents
        onClose={onClose}
        selectedGroupId={selectedGroupId!}
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
        nurseData={nurseData}
        precepteePeriods={precepteePeriods}
        shiftsData={shiftsData}
        isUseMid={isUseMid}
      />
    </CustomModal.Panel>
  );
};

export default NurseActiveSwitch;
